import React from 'react';
import {RequiredAstrix} from "./FormElements";
import PropTypes from 'prop-types';

const SelectField = (props) => {
    const {
        id,
        label,
        required,
        name,
        values,
        errors,
        handleChange,
        handleBlur,
        options,
        touched,
        extraClass,
        selectClass
    } = props;
    return (
        <div className={`form-group ${extraClass}`}>
            <label htmlFor={id}>{label} {required && <RequiredAstrix/>}</label>
            <select
                name={name}
                className={`form-control ${selectClass}`}
                id={id}
                value={values[name]}
                onChange={handleChange}
                onBlur={handleBlur}
            >
                <option value="" disabled>Select one</option>
                {options.map((item, idx) => <option key={idx}>{item.label}</option>)}
            </select>
            {touched[name] && errors[name] && <span className={'invalid'}>{errors[name]}</span>}
        </div>
    )
}

SelectField.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    required: PropTypes.bool,
    name: PropTypes.string,
    values: PropTypes.object,
    errors: PropTypes.object,
    handleChange: PropTypes.func,
    handleBlur: PropTypes.func,
    options: PropTypes.array,
    touched: PropTypes.object,
    extraClass: PropTypes.string,
    selectClass: PropTypes.string
}

SelectField.defaultProps = {
    extraClass: '',
    selectClass: '',
    required: false
}

export default SelectField;
